import React from 'react'
import CategoryForm from '../CategoryForm'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import rubricSelectors from '../../../../../../store/selectors/rubric.selectors'
import { useFetchRubricsQuery } from '../../../../../../store/apis/rubric.api'
import { useUpdateCategoryMutation } from '../../../../../../store/apis/question.api'
import { fetchRubricsSelectors } from '../../../../../../store/apis/utils/selectors/rubric.api.selectors'
import { openNotificationWithIcon } from '../../../../../../utils/notification.helper'
import DeleteCategoryButton from './DeleteCategoryButton'

const EditCategoryForm = ({ onSuccess }) => {
    const { token } = useParams()
    const editingCategoryId = useSelector(rubricSelectors.editingCategoryId)

    const { data: category } = useFetchRubricsQuery({ token }, {
        selectFromResult: result => fetchRubricsSelectors.pattern({ patternId: editingCategoryId }, result),
    })

    const [updateCategory, updateCategoryResult] = useUpdateCategoryMutation()

    const onSubmit = async values => {
        const response = await updateCategory({
            ...category,
            ...values,
            conceptualLabels: values.conceptualLabels,
        })
        if ('data' in response) {
            openNotificationWithIcon('success', 'Category updated successfully')
            onSuccess()
        }
    }

    const initialValues = {
        name: category?.name,
        feedback: category?.feedback,
        description: category?.description,
        colorId: category?.colorId ?? category?.id,
        grade: category?.grade,
        conceptualLabels: category?.conceptualLabels,
        philosophyText: category?.philosophyText,
        autoApprove: category?.autoApprove !== undefined ? category.autoApprove : true,
    }

    return (
        <CategoryForm
            initialValues={initialValues}
            onSubmit={onSubmit}
            error={updateCategoryResult?.error}
            loading={updateCategoryResult?.isLoading}
            actionName='Save'
            extraActions={[<DeleteCategoryButton 
                key={editingCategoryId}
                onSuccess={onSuccess}
            />]}
        />
    )
}

export default EditCategoryForm
